export const HOME = {
  emergentLink: "emergent-link",
};

export const TESTIDS = {
  navHome: "nav-link-home",
  navServices: "nav-link-services",
  navWhy: "nav-link-why",
  navCompliance: "nav-link-compliance",
  navFaq: "nav-link-faq",
  navContact: "nav-link-contact",
  navWhatsappCta: "nav-whatsapp-cta",
  heroSection: "hero-section",
  heroPrimaryCta: "hero-primary-cta-whatsapp",
  heroSecondaryCta: "hero-secondary-cta",
  complianceBadge: "compliance-badge",
  complianceSection: "compliance-section",
  complianceWhatsapp: "compliance-whatsapp-cta",
  servicesGrid: "services-bento-grid",
  customizeSection: "customize-section",
  whySection: "why-section",
  processSection: "process-section",
  examplesSection: "examples-section",
  faqSection: "faq-section",
  faqItem: (i) => `faq-item-${i}`,
  finalCtaSection: "final-cta-section",
  finalCtaWhatsapp: "final-cta-whatsapp",
  footer: "site-footer",
  footerWhatsapp: "footer-whatsapp-link",
  floatingWhatsapp: "whatsapp-floating-cta",
  cookieBanner: "cookie-banner",
  cookieAccept: "cookie-accept",
  cookieReject: "cookie-reject",
};
